import React, { useState } from 'react';
import { X, BellRing } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-9">
      <motion.div initial={{
      y: -50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -50,
      opacity: 0
    }} className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white px-4 py-3 shadow-lg" data-id="element-10">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-11">
          <div className="flex items-center gap-3 flex-1 justify-center" data-id="element-12">
            <motion.div animate={{
            rotate: [0, -10, 10, -10, 10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            repeatDelay: 3
          }} data-id="element-13">
              <BellRing className="w-5 h-5 text-yellow-300 shrink-0" data-id="element-14" />
            </motion.div>
            <p className="text-sm md:text-base font-medium font-body text-center" data-id="element-15">
              <span className="font-bold text-yellow-300 tracking-wider" data-id="element-16">
                OFERTA DE LANZAMIENTO:
              </span>{' '}
              Obtén el nuevo libro inspirado en enseñanzas de Brian Tracy + El
              AUDIOLIBRO con un{' '}
              <span className="font-bold underline decoration-yellow-300 underline-offset-2" data-id="element-17">
                90% de descuento
              </span>{' '}
              solo por hoy.
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="p-1 hover:bg-red-700 rounded-full transition-colors shrink-0" aria-label="Cerrar alerta" data-id="element-18">
            <X className="w-5 h-5" data-id="element-19" />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}